import BaseKit from '@/tiptap/extensions/base-kit'
import History from '@/tiptap/extensions/history'
import Blockquote from '@/tiptap/extensions/blockquote'
import HorizontalRule from '@/tiptap/extensions/horizontal-rule'
import Table from '@/tiptap/extensions/table'
import Bold from '@/tiptap/extensions/bold'
import Italic from '@/tiptap/extensions/italic'
import Underline from '@/tiptap/extensions/underline'
import Strike from '@/tiptap/extensions/strike'
import Highlight from '@/tiptap/extensions/highlight'
import SubAndSuperScript from '@/tiptap/extensions/subAndSuperScript'
import Color from '@/tiptap/extensions/color'
import BulletList from '@/tiptap/extensions/bullet-list'
import OrderedList from '@/tiptap/extensions/ordered-list'
import TaskList from '@/tiptap/extensions/task-list'
import Indent from '@/tiptap/extensions/indent'
import Link from '@/tiptap/extensions/link'
import { Image } from '@/tiptap/extensions/image'
import Video from '@/tiptap/extensions/video'
import FontFamily from '@/tiptap/extensions/font-family'
import FontSize from '@/tiptap/extensions/font-size'
import FontWeight from '@/tiptap/extensions/font-weight'
import LetterSpacing from '@/tiptap/extensions/letter-spacing'
import TextAlignMenu from '@/tiptap/extensions/text-align'
import Clear from '@/tiptap/extensions/clear'
import Heading from '@/tiptap/extensions/heading'

const all = [
  BaseKit,
  History,
  Bold,
  Italic,
  Underline,
  Strike,
  Highlight,
  SubAndSuperScript,
  Color,
  BulletList,
  OrderedList,
  TaskList,
  Indent,
  Link,
  Image,
  Video,
  FontFamily,
  FontSize,
  FontWeight,
  LetterSpacing,
  TextAlignMenu,
  Clear,
  Blockquote,
  HorizontalRule,
  Table,
  Heading,
]

export { all }
export default all
